import { useField } from "formik";
import React from "react";
import { useState } from "react";
import * as styles from './styles.module.sass'
import classNames from "classnames";
import { Icon } from "../../atoms/icon";
import { Size } from "../../enums/size";
import InputMask from 'react-input-mask';
import { TextareaProps } from "./props.type";
import { FieldWrapper } from "../FieldWrapper/FieldWrapper";


export const Textarea = React.memo((props: TextareaProps) => {
  const { name, placeholder = '', disabled = false, wrapperClassName, labelClassName } = props;
  
  const [field, meta, helper] = useField(name);

  const { form_element, input_wrapper } = styles;


  const textareaChangeHandler = async (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    helper.setTouched(true, true);
    helper.setValue(event.target.value);
  };
  

  return (
    <FieldWrapper
      size={props.size ? props.size : Size.BIG}
      {...props}
      errors={props.errors || meta.error}
      wrapperClassName={wrapperClassName}
    >
      <label className={classNames(input_wrapper, { 'no-min': props.noMin }, labelClassName)}>
        <textarea
          id={name}
          name={name}
          placeholder={placeholder}
          disabled={disabled}
          onChange={textareaChangeHandler}
          className={classNames(form_element, props.className)}
        ></textarea>
        {!!meta.error && meta.touched && <Icon icon="error" className={styles.icon} />}
      </label>
    </FieldWrapper>
  );
});
